<div class="modal-header">
    <h4 class="modal-title">{{ "navigation.tooltips.display_order" | translate }}</h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.close()"></button>
</div>
<div class="modal-body">
    <adaa-draggable-sort-list
        [showNumber]="true"
        [label]="inputLabel | translate"
        [list]="data"
        (listChanged)="values.set($event)"
    ></adaa-draggable-sort-list>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">{{ "common.form.button.close" | translate }}</button>
    <button type="button" class="btn btn-primary" (click)="save()">{{ "common.form.button.save" | translate }}</button>
</div>
